import(/* webpackMode: "eager" */ "/builds/magic.ai/frontend/magicsquare/apps/store-web/app/global-error.tsx");
